/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import style from './style.module.css'

const ImageHover = ({
  image,
  text
}) => {
  return (
    <div className={style.imageArea}>
      <img className={style.imageArea__img} src={image} alt='image' />
      <div className={style.imageArea__text}>{text}</div>
    </div>
  )
}

export default ImageHover
